import { ResponsiveBlockSwitcher } from "@/shared/Components";
import type { ContactsFilterProps } from "@/entities/contacts-filters/model";
import { ContactsFiltersDesktop } from "./components/desktop";
import { ContactsFiltersMobile } from "./components/mobile";

export const ContactsFilters = ({ setFilter, groupFilter }: ContactsFilterProps) => {
  return (
    <ResponsiveBlockSwitcher
      desktop={<ContactsFiltersDesktop setFilter={setFilter} groupFilter={groupFilter} />}
      mobile={<ContactsFiltersMobile />}
    />
  );
};
